/**
 * quiz.js — Quiz tìm vang (mục 28): mỗi màn một câu, thanh tiến độ, kết quả 3 chai.
 *
 * Markup: form[data-quiz] chứa
 *   fieldset[data-quiz-step] × N   mỗi câu một nhóm radio thật (name = khoá câu trả lời)
 *   [data-quiz-label] [data-quiz-progress]           "Bước 1 / 4" + thanh tiến độ (--pct)
 *   button[data-quiz-goto="i"] > [data-quiz-answer]  thanh 4 bước ở cột trái: li cha nhận .is-current / .is-done,
 *                                                    dòng phụ hiện đáp án đã chọn; bấm để quay lại sửa câu đó
 *   [data-quiz-back] [data-quiz-next] [data-quiz-next-label] [data-quiz-nav]
 *   [data-quiz-result] > [data-quiz-summary] [data-quiz-results] [data-quiz-add-all] [data-quiz-restart]
 *
 * Bàn phím: mũi tên đổi đáp án trong nhóm radio (trình duyệt lo sẵn), Enter = Tiếp tục
 * (submit), sang câu mới thì focus vào câu hỏi để trình đọc màn hình đọc ngay.
 *
 * Kết quả: chấm điểm 12 chai của window.WBCatalog — lọc theo loại vang, cộng điểm cho
 * khớp ngân sách / khẩu vị (độ cồn) / dịp dùng, bỏ chai hết hàng; thiếu thì bù bằng 3
 * chai mặc định. Nhãn 96% / 91% / 87% lấy đúng như bản vẽ — điểm thật chỉ dùng để xếp hạng.
 *
 * Thanh bước: mở được bước đã trả lời và bước ngay sau câu cuối đã trả lời — không nhảy cóc qua câu trống
 * (kết quả cần đủ 4 đáp án). Đang xem kết quả mà bấm một bước thì quay về câu đó để sửa.
 *
 * WP: kết quả do PHP trả (AJAX wb_quiz hoặc GET về trang) — xoá phần chấm điểm,
 * giữ phần chuyển câu / thanh tiến độ / thanh bước.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var form = document.querySelector('[data-quiz]');
    if (!form) return;

    var MATCH = ['96%', '91%', '87%'];
    var FALLBACK = ['chateau-margaux', 'penfolds-bin-389', 'barolo-riserva'];
    var TYPES = {
        red: ['Vang đỏ'],
        white: ['Vang trắng'],
        'rose-sparkling': ['Vang hồng', 'Vang sủi'],
        any: null
    };

    var steps = [].slice.call(form.querySelectorAll('[data-quiz-step]'));
    var label = form.querySelector('[data-quiz-label]');
    var progress = form.querySelector('[data-quiz-progress]');
    var back = form.querySelector('[data-quiz-back]');
    var next = form.querySelector('[data-quiz-next]');
    var nextLabel = form.querySelector('[data-quiz-next-label]');
    var nav = form.querySelector('[data-quiz-nav]');
    var result = form.querySelector('[data-quiz-result]');
    var summary = form.querySelector('[data-quiz-summary]');
    var list = form.querySelector('[data-quiz-results]');
    var addAll = form.querySelector('[data-quiz-add-all]');
    var restart = form.querySelector('[data-quiz-restart]');
    var gotos = [].slice.call(form.querySelectorAll('[data-quiz-goto]'));

    var current = 0;
    var picks = []; // id các chai đang hiện ở kết quả — cho nút "Thêm cả 3 vào giỏ"

    // JS lo chuyển câu nên tắt kiểm tra required của trình duyệt: câu 2–4 đang ẩn
    // mà còn trống thì submit bị chặn kèm bong bóng lỗi trỏ vào phần tử không nhìn thấy.
    form.noValidate = true;

    function esc(value) {
        return String(value == null ? '' : value).replace(/[&<>"']/g, function (ch) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
        });
    }

    function checked(step) {
        return step ? step.querySelector('input[type="radio"]:checked') : null;
    }

    function answerLabel(step) {
        var input = checked(step);
        var title = input ? input.closest('label').querySelector('.option-card__title') : null;
        return title ? title.textContent.trim() : '';
    }

    // Bước i mở được khi mọi câu trước nó đã có đáp án
    function reachable(i) {
        for (var k = 0; k < i; k++) {
            if (!checked(steps[k])) return false;
        }
        return true;
    }

    function syncSteps(finished) {
        gotos.forEach(function (btn) {
            var i = parseInt(btn.getAttribute('data-quiz-goto'), 10);
            var item = btn.closest('li') || btn;
            var answered = !!checked(steps[i]);
            var here = !finished && i === current;
            item.classList.toggle('is-current', here);
            item.classList.toggle('is-done', answered && !here);
            btn.disabled = !reachable(i);
            if (here) btn.setAttribute('aria-current', 'step');
            else btn.removeAttribute('aria-current');
            var value = btn.querySelector('[data-quiz-answer]');
            if (value) value.textContent = answered ? answerLabel(steps[i]) : here ? 'Đang chọn' : 'Chưa chọn';
        });
    }

    function setProgress(pct, text, now) {
        if (label) label.textContent = text;
        if (!progress) return;
        progress.style.setProperty('--pct', pct + '%');
        progress.setAttribute('aria-valuenow', String(now));
        progress.setAttribute('aria-valuetext', text);
    }

    // ----- Chuyển câu -----
    function show(index, focus) {
        current = index;
        var total = steps.length;
        steps.forEach(function (step, i) {
            step.hidden = i !== index;
        });
        result.hidden = true;
        nav.hidden = false;

        // Bản vẽ: câu k (từ 0) lấp k/N + 8% — thanh không bao giờ trống ở câu đầu
        setProgress(Math.round((index / total) * 100 + 8), 'Bước ' + (index + 1) + ' / ' + total, index + 1);
        back.disabled = index === 0;
        nextLabel.textContent = index === total - 1 ? 'Xem kết quả' : 'Tiếp tục';
        syncNext();
        syncSteps(false);

        if (focus) steps[index].querySelector('.quiz__question').focus();
    }

    function syncNext() {
        next.disabled = !checked(steps[current]);
    }

    function goNext() {
        if (!checked(steps[current])) return;
        if (current < steps.length - 1) show(current + 1, true);
        else showResult();
    }

    // ----- Chấm điểm -----
    function answers() {
        var data = {};
        steps.forEach(function (step) {
            var input = checked(step);
            if (input) data[input.name] = input.value;
        });
        return data;
    }

    function budgetRange(value) {
        var parts = String(value || '').split('-');
        var min = parseInt(parts[0], 10) || 0;
        var max = parseInt(parts[1], 10) || Infinity; // "3000000-0" = không giới hạn trên
        return [min, max];
    }

    function abv(p) {
        return parseFloat(String(p.abv).replace(',', '.')) || 13.5;
    }

    function score(p, a) {
        var s = 0;
        var range = budgetRange(a.budget);
        if (p.price >= range[0] && p.price < range[1]) {
            s += 40;
        } else {
            // Lệch ngân sách: trừ dần theo % chênh — chai rẻ hơn 10% vẫn hơn chai đắt gấp đôi
            var edge = p.price < range[0] ? range[0] : range[1];
            s += Math.max(0, 20 - (Math.abs(p.price - edge) / edge) * 40);
        }

        var alc = abv(p);
        if (a.taste === 'bold') s += alc >= 14 ? 20 : alc >= 13.5 ? 8 : 0;
        if (a.taste === 'light') s += alc <= 13 ? 20 : alc <= 13.5 ? 8 : 0;
        if (a.taste === 'balanced') s += alc >= 13 && alc <= 14 ? 20 : 6;

        if (a.occasion === 'gift') s += p.rating * 4;
        if (a.occasion === 'family') s += p.price < 1000000 ? 10 : 4;
        if (a.occasion === 'date') s += p.type === 'Vang hồng' || p.type === 'Vang sủi' ? 14 : p.rating * 2;
        if (a.occasion === 'party') s += (p.stock >= 15 ? 10 : 0) + (p.price < 1000000 ? 8 : 0);

        return s;
    }

    function recommend(a) {
        var catalog = window.WBCatalog;
        if (!catalog) return [];
        var types = TYPES[a.type] || null;
        var ranked = catalog.all().filter(function (p) {
            // Hết hàng thì không gợi ý — khách bấm "Thêm cả 3" sẽ hụt một chai
            return p.stock !== 0 && (!types || types.indexOf(p.type) !== -1);
        }).map(function (p) {
            return { p: p, s: score(p, a) };
        }).sort(function (x, y) {
            return y.s - x.s || y.p.rating - x.p.rating;
        }).map(function (x) {
            return x.p;
        });

        var out = ranked.slice(0, 3);
        FALLBACK.concat(catalog.all().map(function (p) {
            return p.id;
        })).forEach(function (id) {
            if (out.length >= 3) return;
            var p = catalog.get(id);
            if (p && out.indexOf(p) === -1) out.push(p);
        });
        return out;
    }

    // Cùng markup với partials/product-card.html (bản gọn) để dùng lại CSS + cart.js + wishlist.js
    function card(p, match) {
        var wished = window.WBStore && window.WBStore.wishlist.has(p.id);
        var money = window.WBStore ? window.WBStore.money : String;
        return '<article class="product-card product-card--compact" data-product data-product-id="' + esc(p.id) + '">' +
            '<div class="product-card__media">' +
            '<a class="product-card__image" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' +
            '<img src="' + esc(p.image) + '" alt="" width="600" height="800" loading="lazy" /></a>' +
            '<span class="quiz-match">' + match + ' phù hợp</span>' +
            '<button class="wish-btn" type="button" aria-pressed="' + !!wished + '" aria-label="' +
            (wished ? 'Bỏ khỏi yêu thích' : 'Thêm vào yêu thích') + '" data-wishlist-toggle>' +
            '<i class="' + (wished ? 'ph-fill' : 'ph-bold') + ' ph-heart" aria-hidden="true"></i></button></div>' +
            '<div class="product-card__body">' +
            '<p class="origin"><img class="flag" src="images/flags/' + esc(p.flag) + '.png" alt="" width="40" height="27" loading="lazy" />' +
            '<span>' + esc(p.country) + '</span><span class="origin__sep" aria-hidden="true">·</span><span>' + esc(p.region) + '</span></p>' +
            '<h3 class="product-card__title"><a href="' + esc(p.url) + '">' + esc(p.name) + '</a></h3>' +
            '<div class="product-card__foot"><p class="price">' +
            (p.regularPrice > p.price ? '<del><span class="screen-reader-text">Giá gốc </span>' + money(p.regularPrice) + '</del>' : '') +
            '<ins><span class="screen-reader-text">Giá bán </span>' + money(p.price) + '</ins></p>' +
            '<button class="btn btn--primary btn--compact" type="button" aria-label="Thêm ' + esc(p.name) + ' vào giỏ" data-add-to-cart>' +
            '<i class="ph-bold ph-plus" aria-hidden="true"></i>Thêm</button></div></div></article>';
    }

    function showResult() {
        var products = recommend(answers());
        picks = products.map(function (p) {
            return p.id;
        });

        summary.textContent = steps.map(answerLabel).filter(Boolean).join(' · ');
        list.innerHTML = products.map(function (p, i) {
            return card(p, MATCH[i] || MATCH[MATCH.length - 1]);
        }).join('');

        steps.forEach(function (step) {
            step.hidden = true;
        });
        nav.hidden = true;
        result.hidden = false;
        setProgress(100, 'Hoàn tất', steps.length);
        syncSteps(true);
        result.querySelector('.quiz__result-title').focus();
    }

    function addAllToCart() {
        var s = window.WBStore;
        if (!s) return;
        picks.forEach(function (id) {
            s.cart.add(s.product(id), 1);
        });
        if (window.WBToast) {
            window.WBToast.show('Đã thêm ' + picks.length + ' chai vào giỏ hàng', {
                icon: 'ph-fill ph-check-circle',
                action: { label: 'Xem giỏ', href: 'cart.html' }
            });
        }
    }

    function reset() {
        form.reset();
        picks = [];
        list.innerHTML = '';
        show(0, true);
    }

    // ----- Sự kiện -----
    form.addEventListener('change', function (event) {
        if (event.target.type !== 'radio') return;
        syncNext();
        syncSteps(false);
    });

    form.addEventListener('click', function (event) {
        var btn = event.target.closest ? event.target.closest('[data-quiz-goto]') : null;
        if (btn && !btn.disabled) show(parseInt(btn.getAttribute('data-quiz-goto'), 10), true);
    });

    // Enter trên radio không tự submit ở mọi trình duyệt — tự bắt để "Enter = Tiếp tục"
    form.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' && event.target.type === 'radio') {
            event.preventDefault();
            goNext();
        }
    });

    form.addEventListener('submit', function (event) {
        event.preventDefault();
        goNext();
    });

    back.addEventListener('click', function () {
        if (current > 0) show(current - 1, true);
    });

    if (restart) restart.addEventListener('click', reset);
    if (addAll) addAll.addEventListener('click', addAllToCart);

    // Trình duyệt giữ lựa chọn radio khi bấm Back/Reload — đồng bộ lại nút ngay từ đầu
    show(0, false);
})();
